import { render } from "./SvgWrapper.vue?vue&type=template&id=1e110be0"
import script from "./SvgWrapper.vue?vue&type=script&lang=js"
export * from "./SvgWrapper.vue?vue&type=script&lang=js"

import "./SvgWrapper.vue?vue&type=style&index=0&id=1e110be0&lang=scss"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__